import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import { Image } from "@tecreation/funnel-components"
import { useEffect } from "react"

export function TabletSaunaBoatBase({ children }) {
	const { push } = useCustomNavigation()
	useEffect(() => {
		let timer = setTimeout(
			() => {
				push("/tablet-sauna-boat-1")
			},
			5 * 1000 * 60 * 60,
		)
		return () => clearTimeout(timer)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<div className="h-100 w-100 flex">
			<Image
				asBackground
				src="img/sauna_boat_image_315X820.png"
				style={{ height: "100%", width: "30%", backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center center" }}
			/>
			<div className="flex-1 ml-8 mt-8 flex flex-column">
				<div className="f1 color-fg-secondary">Saunaboot Freya</div>
				<div className="rounded-3 border flex-1 m-6 ml-0 boxShadow px-4 py-5 flex flex-column">{children}</div>
			</div>
		</div>
	)
}
